module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/BrandParoc-ec212b8163eee66907b46c1c9e902dc5.png";